import React from 'react'

export const Loading = () => (
  <>
    <div className="upos-loading-screen upos-text text-tur-dark upos-text-h1"></div>
    <img className="upos-loading-img" src="/svg/bike-loading.gif" />
  </>
)
